export interface NavItem {
  title: string
  path: string
}

export interface NavSection {
  title: string
  icon: string
  items: NavItem[]
}

export const nav: NavSection[] = [
  {
    title: 'Getting Started',
    icon: '🚀',
    items: [
      { title: 'Introduction', path: '/docs/introduction' },
      { title: 'Architecture', path: '/docs/architecture' },
      { title: 'Quick Start', path: '/docs/quick-start' },
    ],
  },
  {
    title: 'Identity & Access',
    icon: '🔐',
    items: [
      { title: 'Users', path: '/docs/identity/users' },
      { title: 'Roles & Permissions', path: '/docs/identity/roles' },
      { title: 'Paths (Authorization)', path: '/docs/identity/paths' },
      { title: 'API Keys', path: '/docs/identity/api-keys' },
    ],
  },
  {
    title: 'Events — BUZZ',
    icon: '⚡',
    items: [
      { title: 'Overview', path: '/docs/events/overview' },
      { title: 'Subscriptions', path: '/docs/events/subscriptions' },
    ],
  },
  {
    title: 'Mail',
    icon: '📬',
    items: [
      { title: 'Mailboxes', path: '/docs/mail/mailboxes' },
      { title: 'Emails', path: '/docs/mail/emails' },
    ],
  },
  {
    title: 'Storage',
    icon: '🗄️',
    items: [
      { title: 'Datasets',               path: '/docs/storage/datasets' },
      { title: 'Documents',              path: '/docs/storage/documents' },
      { title: 'PDF Templates',          path: '/docs/storage/pdf-templates' },
    ],
  },
  {
    title: 'Brainer · Data Model',
    icon: '🧠',
    items: [
      { title: 'Overview', path: '/docs/brainer/overview' },
      { title: 'Ingredients & Traits', path: '/docs/brainer/ingredients' },
      { title: 'Cups (Entity Types)', path: '/docs/brainer/cups' },
      { title: 'Relations', path: '/docs/brainer/relations' },
      { title: 'Records (Coffees)', path: '/docs/brainer/records' },
    ],
  },
  {
    title: 'Brainer · Workflows',
    icon: '⚙️',
    items: [
      { title: 'Steps', path: '/docs/brainer/steps' },
      { title: 'Drinkers (Scripts)', path: '/docs/brainer/drinkers' },
      { title: 'Preparations', path: '/docs/brainer/preparations' },
      { title: 'Journeys', path: '/docs/brainer/journeys' },
    ],
  },
  {
    title: 'Brainer · Plates',
    icon: '📊',
    items: [
      { title: 'What are Plates?', path: '/docs/plates/overview' },
      { title: 'Sections & Layout', path: '/docs/plates/sections' },
      { title: 'View Types', path: '/docs/plates/views' },
      { title: 'Coffee API Mode', path: '/docs/plates/coffee-api' },
      { title: 'Input Parameters', path: '/docs/plates/input-params' },
      { title: 'Filters & Ordering', path: '/docs/plates/filters' },
      { title: 'Output Mappings', path: '/docs/plates/output-mappings' },
      { title: 'Preparation Views', path: '/docs/plates/preparation-views' },
      { title: 'OpenPlace (Public)', path: '/docs/plates/openplace' },
    ],
  },
  {
    title: 'Connectors',
    icon: '🔌',
    items: [
      { title: 'Funnels', path: '/docs/connectors/funnels' },
    ],
  },
  {
    title: 'Observability',
    icon: '📡',
    items: [
      { title: 'Overview',            path: '/docs/observability/overview' },
      { title: 'Metrics (Prometheus)', path: '/docs/observability/metrics' },
      { title: 'Tracing (OTel)',       path: '/docs/observability/tracing' },
    ],
  },
]

export const flatNav: NavItem[] = nav.flatMap(s => s.items)

export function findSection(path: string): NavSection | undefined {
  return nav.find(s => s.items.some(i => i.path === path))
}

export function findItem(path: string): NavItem | undefined {
  return flatNav.find(i => i.path === path)
}

export function adjacentItems(path: string): { prev?: NavItem; next?: NavItem } {
  const idx = flatNav.findIndex(i => i.path === path)
  return {
    prev: idx > 0 ? flatNav[idx - 1] : undefined,
    next: idx < flatNav.length - 1 ? flatNav[idx + 1] : undefined,
  }
}
